module.exports = __webpack_public_path__ + "static/media/IMG_1505.be96c7e8.jpg";